// import React from 'react';

// // Placed outside the main component to prevent re-creation on re-renders, as per guidelines.
// const HomeIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
//   </svg>
// );


// const NotFoundPage = () => {
//   return (
//     <div className="relative p-8 md:p-12 bg-slate-900/60 rounded-2xl shadow-2xl shadow-black/40 ring-1 ring-white/10 backdrop-blur-md">
//       <div className="text-center space-y-6 max-w-md mx-auto">
        
//         <h1 className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
//           404
//         </h1>
        
//         <h2 className="text-2xl md:text-4xl font-extrabold text-slate-100 tracking-tight">
//           Oops! You're Lost in Space.
//         </h2>
        
//         <p className="text-base md:text-lg text-slate-400">
//           The page you are looking for seems to have drifted away into the cosmic void. Let's get you back to familiar territory.
//         </p>

//         <a
//           href='/'
//           className="mt-4 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 focus:ring-offset-slate-900 transition-all duration-300 ease-in-out transform hover:scale-105 shadow-lg shadow-indigo-500/30"
//         >
//           <HomeIcon />
//           Return to Homepage
//         </a>
//       </div>
//       {/* Decorative blurred blobs */}
//       <div className="absolute -top-10 -left-10 w-24 h-24 bg-purple-500/20 rounded-full filter blur-2xl -z-10"></div>
//       <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-pink-500/20 rounded-full filter blur-2xl -z-10"></div>
//     </div>
//   );
// };

// export default NotFoundPage;


import React from 'react';
// import './NotFoundPage.css';

const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="home-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </svg>
);

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-heading">Oops! You're Lost in Space.</h2>
        <p className="not-found-text">
          The page you are looking for seems to have drifted away into the cosmic void.
          Let's get you back to familiar territory.
        </p>

        <a href="/" className="not-found-button">
          <HomeIcon />
          Return to Homepage
        </a>
      </div>

      <div className="blob blob-purple"></div>
      <div className="blob blob-pink"></div>
    </div>
  );
};

export default NotFoundPage;
